import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';

export default function CookiesPopup() {
    const [cookiesState, setCookiesState] = useState<boolean>(false);
    useEffect(() => {
        const _cookies = Cookies.get('Cookies-shown');
        if (!_cookies) return;
        if (JSON.parse(_cookies)) setCookiesState(true);
        else setCookiesState(false);
    }, []);

    if (!cookiesState)
        return (
            <div
                className={
                    'fixed bottom-0 z-[45] flex w-full flex-row items-center justify-center gap-5 border-t-2 border-SM-yellow bg-white px-10 py-5'
                }>
                <p className={'text-xs'}>
                    <Trans
                        i18nKey={'translation:COOKIES.INFORMATION'}
                        components={{
                            privacy: <Link to={'/statute/privacy'} className={'link'} />,
                        }}
                    />
                </p>

                <button
                    onClick={() => {
                        Cookies.set('Cookies-shown', JSON.stringify(true), {
                            expires: new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000),
                        });
                        setCookiesState(true);
                    }}
                    className={'btn-filled bg-SM-yellow text-sm text-white ring-SM-yellow '}>
                    OK
                </button>
            </div>
        );
    else return <></>;
}
